import { render, staticRenderFns } from "./CaixaAberto.vue?vue&type=template&id=ebe14de2&scoped=true"
import script from "./CaixaAberto.vue?vue&type=script&lang=js"
export * from "./CaixaAberto.vue?vue&type=script&lang=js"
import style0 from "./CaixaAberto.vue?vue&type=style&index=0&id=ebe14de2&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "ebe14de2",
  null
  
)

export default component.exports